/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StorNextConnection
 */
export interface StorNextConnection {
    /**
     * 
     * @type {string}
     * @memberof StorNextConnection
     */
    index: string;
    /**
     * 
     * @type {string}
     * @memberof StorNextConnection
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof StorNextConnection
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof StorNextConnection
     */
    uptime?: string;
    /**
     * 
     * @type {string}
     * @memberof StorNextConnection
     */
    license?: string;
}

export function StorNextConnectionFromJSON(json: any): StorNextConnection {
    return StorNextConnectionFromJSONTyped(json, false);
}

export function StorNextConnectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorNextConnection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'index': json['index'],
        'type': json['type'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'uptime': !exists(json, 'uptime') ? undefined : json['uptime'],
        'license': !exists(json, 'license') ? undefined : json['license'],
    };
}

export function StorNextConnectionToJSON(value?: StorNextConnection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'index': value.index,
        'type': value.type,
        'location': value.location,
        'uptime': value.uptime,
        'license': value.license,
    };
}


